import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import type { ICropFailedOrdersContextValue } from './types';

export default createContext<ICropFailedOrdersContextValue>({
  state: initialState,
  actions: initialActionsState,
});
